import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api, loadAuthToken } from "../../lib/api";
import { isAdmin } from "../../lib/customers";

const KEY = "ap_research_notified";
const istHM = () => new Date().toLocaleTimeString("en-GB", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit" });

// Browser notifications only while the site is open (no push when closed)
export const ResearchReminder = () => {
  const { pathname } = useLocation();
  const on = pathname.startsWith("/admin") && pathname !== "/admin/login" && !!loadAuthToken() && isAdmin();
  useEffect(() => {
    if (!on) return;
    const tick = async () => {
      if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
      try {
        const { data: s } = await api.get("/research/summary");
        const seen = new Set(JSON.parse(localStorage.getItem(KEY) || "[]"));
        const fire = (k, title, body) => { if (!seen.has(k)) { new Notification(title, { body, tag: k }); seen.add(k); } };
        const open = s.today_due + s.missed - (s.snoozed || 0);
        if (open > 0) {
          fire(`day:${s.check_day}`, "आज के दैनिक चेक", `${s.today_due} चेक बाकी · ${s.missed} छूटे हुए`);
          (s.reminder_times || []).filter((t) => istHM() >= t).forEach((t) => fire(`rem:${s.check_day}:${t}`, "चेक अभी बाकी है", `${open} चेक बाकी`));
        }
        (s.deadlines || []).forEach((d) => fire(`dl:${d.id}:${d.days_left}`, "अंतिम तारीख नजदीक", `${d.title} — ${d.days_left === 0 ? "आज" : `${d.days_left} दिन`}`));
        localStorage.setItem(KEY, JSON.stringify([...seen].slice(-300)));
      } catch { /* silent */ }
    };
    tick();
    const iv = setInterval(tick, 60000);
    return () => clearInterval(iv);
  }, [on]);
  return null;
};
